/** Payload (claims) di un JWT senza verifica della firma: serve solo a leggere i claim del token. */
const decodeJwtPayload = token => {
  if (!token || typeof token !== "string") {
    return {};
  }
  try {
    const payload = token.split(".")[1];
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    const json = decodeURIComponent(
      atob(padded)
        .split("")
        .map(c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join("")
    );
    return JSON.parse(json);
  } catch (error) {
    return {};
  }
};

/**
 * Utente SSO (ruolo di realm Keycloak `sso-only`, configurabile con REACT_APP_SSO_ONLY_ROLE): accede solo
 * tramite l'identity provider aziendale e non ha un account locale da gestire, quindi niente "Profilo".
 * Il ruolo si legge da `realm_access` dell'access token (il profilo userinfo non lo contiene).
 */
export const isSsoOnlyUser = accessToken => {
  const ssoOnlyRole = (process.env.REACT_APP_SSO_ONLY_ROLE || "").trim() || "sso-only";
  const roles = decodeJwtPayload(accessToken).realm_access?.roles;
  return Array.isArray(roles) && roles.includes(ssoOnlyRole);
};
